import { useEffect, useState } from 'react';
import { supabase } from './lib/supabaseClient';
import Catalog from './components/Catalog';
import AdminPanel from './components/AdminPanel';
import AdminLogin from './components/AdminLogin';

export default function App() {
  const [session, setSession] = useState(null);
  const isAdminRoute = window.location.pathname.startsWith('/admin');

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setSession(data.session));
    const { data: listener } = supabase.auth.onAuthStateChange((_event, newSession) => {
      setSession(newSession);
    });
    return () => listener.subscription.unsubscribe();
  }, []);

  if (isAdminRoute) {
    return session ? <AdminPanel session={session} /> : <AdminLogin />;
  }

  return <Catalog />;
}
